import { withAbsoluteImageUrls } from './formPreviewIframeUtils';

export function getEformPdfFitToPagePreference() {
  try {
    return localStorage.getItem('eformReportPdfFitToPage') === 'true';
  } catch {
    return false;
  }
}

/** HTML eForm 可匯出 PDF；MetaFlows JSON 表單不支援 */
export function canExportEformToPdf(fillType, html) {
  const code = (html || '').trim();
  if (!code) return false;
  if (fillType === 'MetaFlows' && code.startsWith('{')) return false;
  return true;
}

export async function fetchEformInstanceDetail(instanceId, token) {
  const response = await fetch(`/api/eforminstances/${instanceId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) {
    const errBody = await response.json().catch(() => ({}));
    throw new Error(errBody?.error || `HTTP ${response.status}`);
  }
  return response.json();
}

export async function exportEformHtmlContentsToPdf({
  htmlContents,
  instanceIds = [],
  fitToPage = getEformPdfFitToPagePreference(),
  token,
  fileName,
}) {
  const baseUrl = typeof window !== 'undefined' ? window.location.origin : '';
  const normalizedHtml = (htmlContents || [])
    .map((html) => withAbsoluteImageUrls(html, baseUrl))
    .filter(Boolean);

  if (normalizedHtml.length === 0) {
    throw new Error('NO_HTML');
  }

  const response = await fetch('/api/reports/eform-instances/export-pdf', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      htmlContents: normalizedHtml,
      fitToPage,
      instanceIds,
    }),
  });

  if (!response.ok) {
    const errBody = await response.json().catch(() => ({}));
    throw new Error(errBody?.error || response.statusText || `HTTP ${response.status}`);
  }

  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName || 'eform_export.pdf';
  a.click();
  URL.revokeObjectURL(url);
}

export async function exportSingleEformInstanceToPdf({
  instanceId,
  html,
  fillType,
  token,
  fileName,
  fitToPage,
}) {
  let resolvedFillType = fillType;
  let resolvedHtml = html;

  if (!resolvedHtml) {
    const detail = await fetchEformInstanceDetail(instanceId, token);
    resolvedFillType = detail.fillType || resolvedFillType;
    resolvedHtml = detail.filledHtmlCode || detail.htmlCode || '';
  }

  if (!canExportEformToPdf(resolvedFillType, resolvedHtml)) {
    throw new Error('META_FLOWS_NOT_SUPPORTED');
  }

  await exportEformHtmlContentsToPdf({
    htmlContents: [resolvedHtml],
    instanceIds: instanceId ? [instanceId] : [],
    fitToPage,
    token,
    fileName,
  });
}
